import { render, staticRenderFns } from "./HideColumnsTable.vue?vue&type=template&id=765d5a30&"
import script from "./HideColumnsTable.vue?vue&type=script&lang=js&"
export * from "./HideColumnsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports